export default "__VITE_ASSET__B1w5muEP__"